import { render, staticRenderFns } from "./Course.tab.vue?vue&type=template&id=39817c11&"
import script from "./Course.tab.vue?vue&type=script&lang=ts&"
export * from "./Course.tab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports